import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Profile = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.7084 24.4104C34.7582 22.8076 36.2566 20.605 36.9948 18.1099C37.733 15.6148 37.6742 12.9515 36.8265 10.4915C35.9789 8.03137 34.3846 5.89715 32.2661 4.38637C30.1476 2.8756 27.6104 2.0636 25.0084 2.0636C22.4064 2.0636 19.8692 2.8756 17.7507 4.38637C15.6322 5.89715 14.038 8.03137 13.1903 10.4915C12.3426 12.9515 12.2838 15.6148 13.022 18.1099C13.7602 20.605 15.2587 22.8076 17.3084 24.4104C13.4359 25.9513 10.114 28.6174 7.77147 32.0647C5.42897 35.5119 4.17338 39.5821 4.16675 43.75V45.8333C4.16675 46.3858 4.38624 46.9158 4.77694 47.3064C5.16764 47.6972 5.69755 47.9166 6.25008 47.9166H43.7501C44.3026 47.9166 44.8325 47.6972 45.2232 47.3064C45.6139 46.9158 45.8334 46.3858 45.8334 45.8333V43.75C45.8281 39.5841 44.575 35.5152 42.2356 32.0682C39.8962 28.6211 36.5779 25.9539 32.7084 24.4104ZM16.6668 14.5833C16.6668 12.9352 17.1555 11.324 18.0712 9.95358C18.9869 8.58318 20.2883 7.51507 21.8111 6.88434C23.3338 6.25361 25.0093 6.08859 26.6258 6.41013C28.2423 6.73167 29.7272 7.52534 30.8926 8.69078C32.0581 9.85622 32.8518 11.3411 33.1733 12.9576C33.4948 14.5741 33.3298 16.2496 32.6991 17.7724C32.0684 19.2951 31.0002 20.5966 29.6298 21.5122C28.2594 22.4279 26.6483 22.9167 25.0001 22.9167C22.7899 22.9167 20.6703 22.0387 19.1075 20.4759C17.5447 18.9131 16.6668 16.7935 16.6668 14.5833ZM8.33342 43.75C8.33342 39.3297 10.0894 35.0905 13.215 31.9649C16.3406 28.8393 20.5798 27.0833 25.0001 27.0833C29.4204 27.0833 33.6596 28.8393 36.7852 31.9649C39.9108 35.0905 41.6668 39.3297 41.6668 43.75H8.33342Z"
        fill={color}
      />
    </svg>
  )
}
